export default {
  colors: {
    background: "#212121",
    primary: "#636363",
    fontColor: "#FFF",
  }
}